import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from 'react';

interface ConfirmOptions {
  alert?: boolean; // se true, entra no modo alerta
  waitSeconds?: number; // tempo de espera para confirmar
  sound?: boolean; // se true, toca um beep
}

export const confirm = (message: string, options: ConfirmOptions = {}) => {
  const { alert = false, waitSeconds = 5, sound = true } = options;

  return new Promise<boolean>((resolve) => {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
    overlay.style.zIndex = '9998';
    document.body.appendChild(overlay);

    const removeOverlay = () => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    };

    // Resolve uma única vez e sempre remove o overlay, mesmo se o toast for descartado
    // sem passar pelos botões (ex.: arrasto).
    let finalizado = false;
    const finalizar = (resultado: boolean) => {
      if (finalizado) return;
      finalizado = true;
      removeOverlay();
      resolve(resultado);
    };

    const ConfirmContent = () => {
      const [countdown, setCountdown] = useState(waitSeconds);

      useEffect(() => {
        // Toca som ao abrir se for alerta
        if (alert && sound) {
          const audio = new Audio(
            "https://actions.google.com/sounds/v1/alarms/beep_short.ogg"
          );
          audio.play().catch(() => {
            // caso o navegador bloqueie autoplay
            console.warn("Som bloqueado pelo navegador");
          });
        }
      }, []);

      useEffect(() => {
        if (alert && countdown > 0) {
          const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
          return () => clearTimeout(timer);
        }
      }, [countdown, alert]);

      return (
        <div style={{ padding: '20px', color: '#333' }}>
          {alert && (
            <div
              style={{
                marginBottom: '16px',
                fontSize: '16px',
                fontWeight: 600,
                color: '#B00020',
                textAlign: 'center',
              }}
            >
              ATENÇÃO MÁXIMA
            </div>
          )}

          <div style={{ marginBottom: '16px', fontSize: '15px', lineHeight: '1.4' }}>
            {message.split('\n').map((line, index) => (
              <p key={index} style={{ margin: 0 }}>
                {line}
              </p>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              onClick={() => {
                finalizar(false);
                toast.dismiss(toastId);
              }}
              style={{
                background: 'transparent',
                color: alert ? '#B00020' : '#1F467E',
                border: `1px solid ${alert ? '#B00020' : '#1F467E'}`,
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: '90px',
              }}
              onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
              onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
            >
              Cancelar
            </button>

            <button
              disabled={alert && countdown > 0}
              onClick={() => {
                finalizar(true);
                toast.dismiss(toastId);
              }}
              style={{
                background: alert
                  ? countdown > 0
                    ? '#ccc'
                    : '#B00020'
                  : '#1F467E',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 600,
                cursor: alert && countdown > 0 ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                minWidth: '110px',
              }}
            >
              {alert && countdown > 0 ? `Aguarde ${countdown}s` : 'Confirmar'}
            </button>
          </div>
        </div>
      );
    };

    const toastId = toast(<ConfirmContent />, {
      closeOnClick: false,
      closeButton: false,
      autoClose: false,
      draggable: false,
      onClose: () => finalizar(false),
      position: 'top-center',
      style: {
        background: 'white',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
        borderRadius: '8px',
        borderLeft: `6px solid ${alert ? '#B00020' : '#1F467E'}`,
        width: 'auto',
        maxWidth: '420px',
        zIndex: '9999',
      },
      bodyStyle: {
        padding: 0,
      },
    });
  });
};
